"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_BUISNESS_SERVICE = exports.FETCH_BUISNESS_SERVICE = "FETCH_BUISNESS_SERVICE";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/workFlow/actionTypes.js
// module id = 2901
// module chunks = 1137